<div class="register-container">
  <div *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>

  <div class="from">
    <h1>{{'createAccount' | translate}}</h1>
    <p>{{'joinOurCreativeCommunity' | translate}}</p>
    <form>
      <!--      first name-->
      <mat-form-field class="half-width">
        <mat-label>{{'orderFormFirstname' | translate}}</mat-label>
        <input type="email" matInput [formControl]="registerFirstNameFormControl" placeholder="firstname">
        <mat-error *ngIf="registerFirstNameFormControl.hasError('required')">
          {{'orderFormFirstNameIs' | translate}} <strong>{{'required' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--      last name-->
      <mat-form-field class="half-width">
        <mat-label>{{'orderFormLastname' | translate}}</mat-label>
        <input matInput [formControl]="registerLastNameFormControl" placeholder="lastname">
        <mat-error *ngIf="registerLastNameFormControl.hasError('required')">
          {{'orderFormLastnameIs' | translate}} <strong>{{'required' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--      email-->
      <mat-form-field class="half-width">
        <mat-label>{{'orderFormEmail' | translate}}</mat-label>
        <input matInput [formControl]="registerEmailFormControl" placeholder="pat@example.com">
        <mat-error *ngIf="registerEmailFormControl.hasError('email') && !registerEmailFormControl.hasError('required')">
          {{'orderFormEmailMustBeValid' | translate}}
        </mat-error>
        <mat-error *ngIf="registerEmailFormControl.hasError('required')">
          {{'orderFormEmailIs' | translate}} <strong>{{'required' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--      phone-->
      <mat-form-field class="half-width">
        <mat-label>{{'orderFormTelephone' | translate}}</mat-label>
        <input type="tel" matInput [formControl]="registerPhoneFormControl" placeholder="0740000000">
        <mat-error *ngIf="registerPhoneFormControl.hasError('required')">
          {{'orderFormTelephoneIs' | translate}} <strong>{{'required' | translate}}</strong>
        </mat-error>
        <mat-error *ngIf="registerPhoneFormControl.hasError('pattern')">
          {{'orderFormTelephoneError' | translate}}
        </mat-error>
      </mat-form-field>

      <!--      pass-->
      <mat-form-field class="half-width">
        <mat-label>{{'password' | translate}}</mat-label>
        <input [type]="hidePassword ? 'password' : 'text'" matInput [formControl]="registerPasswordFormControl" placeholder="">
        <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
          <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="registerPasswordFormControl.hasError('required')">
          {{'orderFormPassword' | translate}} <strong>{{'required' | translate}}</strong>
        </mat-error>
        <mat-error *ngIf="registerPasswordFormControl.hasError('minlength')">
          {{'passwordMin10' | translate}}
        </mat-error>
      </mat-form-field>

      <!--      confirm pass-->
      <mat-form-field class="half-width">
        <mat-label>{{'confirmPassword' | translate}}</mat-label>
        <input  [type]="hideConfirmPassword ? 'password' : 'text'" matInput [formControl]="registerConfirmPasswordFormControl" placeholder="">
        <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideConfirmPassword">
          <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="registerConfirmPasswordFormControl.hasError('required')">
          {{'orderFormConfirmPassword' | translate}} <strong>{{'required' | translate}}</strong>
        </mat-error>
        <mat-error *ngIf="registerConfirmPasswordFormControl.hasError('minlength')">
          {{'passwordMin10' | translate}}
        </mat-error>
      </mat-form-field>

      <!--      account type-->
      <mat-form-field class="half-width">
        <mat-label>{{'orderFormChooseUserType' | translate}}</mat-label>
        <mat-select [formControl]="registerAccountTypeFormControl">
          <mat-option value=""> </mat-option>
          <mat-option value="1">{{'buyer' | translate}}</mat-option>
          <mat-option value="3">{{'wannabeartist' | translate}}</mat-option>
        </mat-select>
        <mat-error *ngIf="registerAccountTypeFormControl.hasError('required')">
          {{'orderFormAccountType' | translate}} <strong>{{'required' | translate}}</strong>
        </mat-error>
      </mat-form-field>
      <p class="artist-account-info full-width">! {{'artistAccountInfo' | translate}}</p>

      <!--      terms and conditions-->
      <div class="checkbox">
        <mat-checkbox [formControl]="registerTermsAndConditionsFormControl" color="primary" class="full-width">{{'agreeWith' | translate}}<a>{{'termsAndConditions' | translate}}</a></mat-checkbox>
        <mat-error *ngIf="registerTermsAndConditionsFormControl.hasError('required')">
          {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
        </mat-error>
      </div>

      <!--      personal data-->
      <div class="checkbox">
        <mat-checkbox [formControl]="registerPersonalDataFormControl" color="primary" class="full-width"><a>{{'agreeWithDataProcessing' | translate}}</a></mat-checkbox>
        <mat-error *ngIf="registerPersonalDataFormControl.hasError('required')">
          {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
        </mat-error>
      </div>

      <p class="error-message">{{errorMessage}}</p>

      <div class="full-width center">
        <button mat-raised-button class="contrast-button" [disabled]="registerForm.invalid" (click)="checkRegister()">{{'register' | translate}}</button>
      </div>
    </form>
  </div>

</div>
